import { FC } from 'react';

import { RootProps } from '../types';
import { Row } from './Row';

export const Root: FC<React.PropsWithChildren<RootProps>> = ({ children }) => {
  return (
    <div className="json-root" data-test="json-root-raw">
      <Row indent={false}>{'{'}</Row>
      {children}
      <Row indent={false}>{'}'}</Row>
    </div>
  );
};
